var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.contactInfo)?_c('v-container',[_c('v-row',{staticClass:"d-flex justify-center align-center",staticStyle:{"margin-top":"20px"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.contactInfoHtml)}})])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }